@if(dataSource.length > 0) {
  <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">
    @for(column of columnsToDisplay; track column) {
      <ng-container [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef>
              @if(column !== 'expand' && column !== 'noName') {
                <div>
                    <span>{{ column }}</span>
                    @if(sortMethods[column]) {
                      <span (click)="sortData(column)" class="icons-outlined sortIcon" matTooltip="Sortieren">{{ sortProperty[column] }}</span>
                    }
                </div>
              }
          </th>
          <td mat-cell *matCellDef="let element; let dataIndex = dataIndex">
              @if(column !== 'expand') {
                <span [matTooltip]="element[column].tooltip">
                    @if(element[column].type === 'string') { 
                      <span (click)="elemClicked(element[column].clickAction)" [class.clickable]="element[column].clickAction">
                        {{ element[column].value }}
                      </span>
                    }
                    @if(element[column].type === 'img') {
                      <img 
                        [src]="element[column].value"
                        alt="Image"
                        (click)="elemClicked(element[column].clickAction)"
                        [class.clickable]="element[column].clickAction"
                      />
                    }
                    @if(element[column].type === 'component') { <ng-container *ngComponentOutlet="element[column].value; inputs: element[column].inputs"></ng-container> }
                </span>
              }
              @if(column === 'expand') {
                <span class="icons-outlined expandArrow" [matTooltip]="element.expandDetails.tooltip + (expandedRowIndex === dataIndex? ' ausblenden' : ' anzeigen')"
                    [class.rotated]="expandedRowIndex === dataIndex"
                    (click)="expandedRowIndex = expandedRowIndex === dataIndex? null : dataIndex">
                    stat_minus_1
                </span>
              }
          </td>
      </ng-container>
    }
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element; let dataIndex = dataIndex" [attr.colspan]="columnsToDisplay.length">
        <div class="element-detail" [@detailExpand]="expandedRowIndex === dataIndex? 'expanded' : 'collapsed'">
          <div class="element-detail-content">
            @if(element.expandDetails.type === 'string') { <span>{{ element.expandDetails.value }}</span> }
            @if(element.expandDetails.type === 'img') { <img [src]="element.expandDetails.value" alt="Image" /> }
            @if(element.expandDetails.type === 'component') { <ng-container *ngComponentOutlet="element.expandDetails.value; inputs: element.expandDetails.inputs"></ng-container> }
          </div>
        </div>
      </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay; let dataIndex = dataIndex"
        class="element-row"
        [class.expanded-row]="expandedRowIndex === dataIndex">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
  </table>
}
@else {
  <div class="empty-table">
      <p>Sie haben noch keine Zertifizierungen erhalten.</p>
  </div>
}